import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

import useDeleteValidator from 'components/Common/Coaches/Hooks/useDeleteValidator';

import falseIcon from 'images/icons/checkbox-red-unchecked.svg';
import trueIcon from 'images/icons/checkbox-green-checked.svg';

import { useContext } from '../Context';

export default function Index({ row, closePopup }) {
  const data = useDeleteValidator(row.id);
  const [buttonEnabled, setButtonEnabled] = useState(false);
  const [loading, setLoading] = useState(false);

  const { dispatch, actions } = useContext();

  useEffect(() => {
    if (data !== null) {
      setButtonEnabled(
        Object.values(data.attributes.items).every((item) => item),
      );
    }
  }, [data]);

  const onDeleteClick = () => {
    setLoading(true);
    actions.destroy(dispatch, row.attributes.user_id, () => {
      closePopup();
    });
  };

  return (
    <Modal
      className="student inmodal auto without-overflow"
      show
      onHide={closePopup}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {`Delete Coach ${row.attributes.full_name}`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <>
          <p>
            Are you sure you want to delete this account?
          </p>
          <p>
            Please ensure all conditions are met before proceeding with the deletion.
          </p>
          {data === null && <div>Please wait, loading data ...</div>}
          {data !== null && (
            <>
              <div>
                {Object.keys(data.attributes.items).map((key) => (
                  <div className="item" key={key}>
                    {data.attributes.items[key]
                      ? <img src={trueIcon} alt="true" />
                      : <img src={falseIcon} alt="true" />}
                    <span className="after-icon" />
                    {key}
                  </div>
                ))}
              </div>
              <div className="text-center">
                <Button bsStyle="primary" onClick={closePopup} className="btn-outline mr5 ml5">
                  Cancel
                </Button>
                <Button
                  onClick={onDeleteClick}
                  bsStyle="primary"
                  disabled={!buttonEnabled || loading}
                  className="mr5 ml5"
                >
                  Delete
                </Button>
              </div>
            </>
          )}
        </>
      </Modal.Body>
    </Modal>
  );
}

Index.propTypes = {
  row: PropTypes.object.isRequired,
  closePopup: PropTypes.func.isRequired,
};
